import { Injectable } from '@angular/core';
import { CommonService } from '../Common.service';
import { RestApiService } from '../rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessGroupLinkService {

  private getOrganizationAgainstProjectUrl = 'Organization/GetOrganizationAgainstProject';
  // private getOrganizationListUrl = 'Organization/GetOrganizationList';
  private saveOrganizationLinkUrl = 'OrganizationLink/PostOrganizationLinks';

  constructor(private restApiService: RestApiService, private commonService: CommonService,) { }


  getMappedOrganizationAgainstProject() {
    return this.restApiService.new_POST(this.getOrganizationAgainstProjectUrl, { projectId: this.commonService.getProjectId() });
  }

  saveOrganization(groupId: number, groupHeadId: number, isActive: boolean) {
    let reqData = {
      "result": "",
      "successCode": 0,
      "successMessage": "",
      "projectId": this.commonService.getProjectId(),
      "createdBy": this.commonService.getLoggedInUserId(),
      "organizationLink": [
        {
          "groupId": groupId,
          "groupHeadId": groupHeadId,
          "isActive": isActive,
        },
      ],
    };

    return this.restApiService.new_POST(this.saveOrganizationLinkUrl, reqData);
  }
}
